// removed by extract-text-webpack-plugin
module.exports = {"signature":"_1xI2BLEf2SN8XW0YmHSFKb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Signature/Image/styles.css
// module id = 3089
// module chunks = 0